import { createContext } from 'react'

export interface A2AssistantLauncher {
  visible: boolean
  open: () => void
}

/** The workspace reports actual pane/drawer visibility to its route shell. */
export const A2AssistantLauncherContext = createContext<
  (launcher: A2AssistantLauncher | null) => void
>(() => undefined)
